import React, { FC } from 'react'

const CurvyLine2: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="682"
    height="2276"
    viewBox="0 0 682 2276"
    fill="none"
  >
    <path
      stroke="#71757D"
      strokeDasharray="14 14"
      strokeLinecap="round"
      strokeOpacity=".5"
      strokeWidth="2"
      d="M680.978 1.5c-51.466 64.223-192.883 149-149.43 232 43.454 83 70.951 142 55.451 231.5-15.5 89.5-76.254 97.534-105.499 176m-67 826.5c-92.999-121.5-347-97-413.5-195M29.5 1882c31.501-74.5 207.999-112 280.998-216.25M36.5 2274.5c-3.59-29.95-27.067-112.52-28-159m8-1062c42.706-106.029 241-101 320.5-214"
    />
  </svg>
)

export default CurvyLine2
